import React from "react";
import HDFCLogo from "./../../../icons/HDFCLogo";
import GenericFeaturedCard from "./../../../shadcn/components/custom/GenericFeaturedCard";
import WhiteBackgroundHeartSvg from "./../../../icons/WhiteBackgroundHeartSvg";
interface PrivateTreatyCardProps {
  tag?: string;
  propertySubType: string;
  price: any;
  auctionDate: any;
  sellerName: any;
  sellerLogo?: any;
  listingId: any;
  onClickHandler: any;
  imageSrc: any;
}
export default function PrivateTreatyCard({
  tag,
  propertySubType,
  price,
  auctionDate,
  sellerName,
  sellerLogo,
  listingId,
  onClickHandler,
  imageSrc,
}: PrivateTreatyCardProps) {
  return (
    <GenericFeaturedCard
      tag="FEATURED"
      propertyType={propertySubType}
      onClickHandler={onClickHandler}
      // location="Rohini, Delhi"
      price={price}
      auctionDate={auctionDate}
      sellerName={sellerName}
      sellerLogo={sellerLogo}
      likeLogo={<WhiteBackgroundHeartSvg />}
      id={listingId}
      imageSrc={imageSrc}
      styles={{
        image: "h-[256px] object-cover",
        container: "hover:drop-shadow hover:shadow-none",
      }}
    />
  );
}
